<div
    [attr.id]="id ? (id + '_container') : null"
    class="agpr-user-notes"
    [ngClass]="{
        'agpr-user-notes-topMargin': scrolling,
        'agpr-user-notes--readonly': readonly
    }"
>
    <div
        *ngIf="!readonly && !panelStyle && !hideAddButton"
        class="agpr-user-notes-addButton-wrapper"
    >
        @if (isNotesTab) {
            <agpr-button
                [id]="id + '_addNewNote_button'"
                icon="fa-regular fa-duotone fa-square-plus"
                tooltip="Discover.userNotes.addNote"
                [style]="buttonTypes.icon"
                (click)="addNote()"
            >
            </agpr-button>
        } @else {
            <agpr-button
                [id]="id + '_addNewNote_button'"
                class="agpr-user-notes-addButton"
                [label]="buttonStyle === buttonTypes.icon ? null :'Discover.userNotes.addNote'"
                [disabled]="disabled"
                [style]="buttonTypes.tertiary || buttonStyle"
                (click)="addNote()"
            >
                <span
                    *ngIf="buttonStyle === buttonTypes.icon"
                    class="fa-regular fa-duotone fa-square-plus agpr-user-notes-addButton"
                    agprTooltip="Discover.userNotes.addNote"
                    tooltipPosition="top"
                ></span>
            </agpr-button>
        }
    </div>

    <div
        *ngIf="disabled && disabledWarningTemplate"
        class="agpr-user-notes-disabledWarning"
    >
        <ng-container [ngTemplateOutlet]="disabledWarningTemplate"></ng-container>
    </div>

    @if (showAddArea) {
        <div
            [attr.id]="id ? (id + '_addNewNote') : null"
            class="agpr-user-notes-container addAreaWrapper"
        >
            <agpr-textarea-input
                [id]="id + '_addNewNote_textarea'"
                class="agpr-user-notes-addTextarea"
                [placeholder]="'Discover.userNotes.placeholder' | localize"
                [initialFocus]="true"
                [(ngModel)]="noteText"
                [bottomMargin]="false"
                [maxLength]="maxLength"
                (blur)="doneAddingNote(noteText)"
                ariaLabel="Discover.userNotes.placeholder"
            ></agpr-textarea-input>

            <div
                [attr.id]="id ? (id + '_addNewNote_details') : null"
                class="agpr-user-notes-details"
            >
                <span [attr.id]="id ? (id + '_addNewNote_author') : null">{{ !!usersMap[currentUser.id] ? usersMap[currentUser.id] : 'Common.unknownUser' | localize }}</span>
                <span
                    [attr.id]="id ? (id + '_addNewNote_date') : null"
                    class="agpr-user-notes-date"
                >{{ currentTime }}</span>
            </div>
        </div>
    }

    @if (!(_userNotes?.length) && !showAddArea) {
        <agpr-message
            [id]="id ? (id + '_noNotes') : null"
            [severity]="messageSeverityEnum.noContent"
            class="agpr-user-notes-noContentMessage"
            [useWhiteBg]="true"
        >
            {{ 'Discover.userNotes.noNotesAdded' | localize }}
        </agpr-message>
    }

    @if (_userNotes?.length) {
        @if (scrolling) {
            <agpr-scroll-panel class="agpr-user-notes-scrollPanel">
                <ng-container *ngTemplateOutlet="noteList"></ng-container>
            </agpr-scroll-panel>
        } @else {
            <ng-container *ngTemplateOutlet="noteList"></ng-container>
        }
    }

    <ng-template #noteList>
        <div
            [attr.id]="id ? (id + '_noteListContainer') : null"
            [class]="isNotesTab? 'agpr-user-notes-listContainer agpr-user-notes-listContainer--tabListContainer' : 'agpr-user-notes-listContainer'"
        >
            <ul
                [id]="id + '_noteList'"
                [attr.aria-label]="'Discover.userNotes.header' | localize"
                agprListKeyboardNavigation
                [list]="_userNotes"
            >
                @for (userNote of _userNotes; track userNote; let i = $index) {
                    <li
                        [id]="id + '_note_' + i"
                        class="agpr-user-notes-container agpr-contextMenu-parent"
                    >
                        @if (inlineEditing && editingNote === userNote) {
                            <agpr-textarea-input
                                [id]="id + '_editNote_textarea_' + i"
                                class="agpr-user-notes-editTextarea"
                                [placeholder]="'Discover.userNotes.placeholder' | localize"
                                [(ngModel)]="noteText"
                                [maxLength]="maxLength"
                                [initialFocus]="true"
                                (blur)="doneEditingNote(noteText)"
                                ariaLabel="Discover.userNotes.placeholder"
                            ></agpr-textarea-input>
                        }

                        @if (editingNote !== userNote) {
                            <pre
                                [id]="id + '_note_' + i + '_text'"
                                [class]="isNotesTab? 'agpr-user-notes-fontStyle agpr-user-notes-fontStyle-tabFontStyle': 'agpr-user-notes-fontStyle'"
                            >{{ userNote.value }}</pre>
                        }

                        <div
                            [attr.id]="id ? (id + '_note_' + i + '_details') : null"
                            [class]="isNotesTab? 'agpr-user-notes-details agpr-user-notes-details-tabDetails' : 'agpr-user-notes-details'"
                        >
                            <span [attr.id]="id ? (id + '_note_' + i + '_author') : null">{{ !!usersMap[userNote.createdUserId] ? usersMap[userNote.createdUserId] : 'Common.unknownUser' | localize }}</span>
                            <span
                                [attr.id]="id ? (id + '_note_' + i + '_date') : null"
                                class="agpr-user-notes-date"
                            >{{ userNote.creationDateDisplayString }}</span>
                        </div>

                        @if (!readonly && editingNote !== userNote && (!selfModificationOnly || currentUser.id === userNote.createdUserId)) {
                            <div
                                [attr.id]="id ? (id + '_note_' + i + '_actions') : null"
                                class="agpr-contextMenu top right"
                            >
                                <agpr-button
                                    [id]="id + '_note_editButton_' + i"
                                    class="agpr-user-notes-container-contextMenu-button"
                                    [style]="buttonTypes.contextMenu"
                                    icon="fa-regular fa-duotone fa-pen"
                                    tooltip="Discover.userNotes.editNote"
                                    tooltipPosition="top"
                                    (click)="editNote(userNote)"
                                ></agpr-button>
                                <agpr-button
                                    [id]="id + '_note_deleteButton_' + i"
                                    class="agpr-user-notes-container-contextMenu-button"
                                    [style]="buttonTypes.contextMenu"
                                    icon="fa-regular fa-duotone fa-trash-can"
                                    tooltip="Discover.userNotes.deleteNote"
                                    tooltipPosition="top"
                                    (click)="deleteNote(userNote)"
                                ></agpr-button>
                            </div>
                        }
                    </li>
                }
            </ul>
        </div>
    </ng-template>
</div>
